<template>
  <div class="card-body p-4 pb-0">
    <div class="row mb-2">
      <div class="col-sm-auto col-md">
        <label for="invoicenoInput">Invoice No</label>
        <input
          type="text"
          class="form-control bg-light border-0"
          id="invoicenoInput"
          placeholder="Invoice No"
          :value="data.invoiceNo"
          disabled
        />
      </div>
      <div class="col-sm-auto col-md">
        <label for="companyAddress">Invoice Type *</label>
        <select
          id="type"
          name="type"
          placeholder="Choose a Invoice Type"
          class="form-control"
          v-model="data.type"
          @change="updateInvoice('type')"
        >
          <option value="invoice">Invoice</option>
          <option value="consignment">Consignment</option>
        </select>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-sm-auto col-md">
        <label for="companyAddress">Biller *</label>
        <select
          id="company"
          name="company"
          placeholder="Choose a Biller"
          class="form-control"
          :disabled="data.status !== 'NEW'"
          v-model="billerID"
          @input="updateBillerID($event.target.value)"
        >
          <option v-for="biller in billers" :value="biller.id" :key="biller.id">
            {{ biller.company }}
          </option>
        </select>
      </div>
      <div class="col-sm-auto col-md">
        <buyer-input-group :key="data.customerID" />
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-sm-auto col-md">
        <label for="date-field">Date</label>
        <DateInput v-model="invoiceDate" @input="updateInvoice('date')" />
      </div>
      <div class="col-sm-auto col-md">
        <label for="totalamountInput">Amount Paid</label>
        <input
          type="text"
          class="form-control bg-light border-0"
          id="totalamountInput"
          :value="priceFormat(data.paid)"
          placeholder="0"
          disabled
        />
      </div>
      <div class="col-sm-auto col-md">
        <label for="totalamountInput">Amount Due</label>
        <input
          type="text"
          class="form-control bg-light border-0"
          id="totalamountInput"
          :value="priceFormat(data.balance)"
          disabled
        />
      </div>
    </div>
    <div class="row mb-2">
      <div v-if="data.type === 'invoice'" class="col-sm-auto col-md">
        <label for="choices-payment-status">Payment Status</label>
        <input
          type="text"
          class="form-control bg-light border-0"
          id="choices-payment-status"
          v-model="data.status"
          disabled
        />
      </div>
      <div v-else class="col-sm-auto col-md">
        <label for="choices-payment-status">Consignment Status</label>
        <select
          name="invoice_status"
          id="invoice_status"
          placeholder="Choose a Invoice Type"
          class="form-control"
          v-model="data.consignmentStatus"
          @change="updateInvoice('consignmentStatus')"
        >
          <option value="DUE">Due</option>
          <option value="PAID">Paid</option>
        </select>
      </div>
      <div class="col-sm-auto col-md">
        <label for="discountRedeemed">Discount Redeemed</label>
        <input
          type="text"
          class="form-control bg-light border-0"
          id="discountRedeemed"
          :value="priceFormat(data.discountRedeemed)"
          disabled
        />
      </div>
      <div class="col-sm-auto col-md">
        <label for="awardPointsRedeemed">Award Points Redeemed</label>
        <input
          type="text"
          class="form-control bg-light border-0"
          id="awardPointsRedeemed"
          v-model="data.awardPointsRedeemed"
          disabled
        />
      </div>
    </div>
    <div class="form-check mb-2">
      <input
        class="form-check-input"
        v-model="data.showSuggestedAnalysis"
        :true-value="1"
        :false-value="0"
        @change="updateInvoice('showSuggestedAnalysis')"
        type="checkbox"
        id="formCheckSuggested"
      />
      <label class="form-check-label" for="formCheckSuggested">
        Show Suggested Analysis
      </label>
    </div>

    <div class="form-check mb-2">
      <input
        class="form-check-input"
        v-model="data.showIndividualMargin"
        :true-value="1"
        :false-value="0"
        @change="updateInvoice('showIndividualMargin')"
        type="checkbox"
        id="formCheckMargin"
      />
      <label class="form-check-label" for="formCheckMargin">
        Show Individual Margin
      </label>
    </div>

    <div class="form-check mb-2">
      <input
        class="form-check-input"
        v-model="data.showDamagedGoods"
        :true-value="1"
        :false-value="0"
        @change="updateInvoice('showDamagedGoods')"
        type="checkbox"
        id="formCheckDamaged"
      />
      <label class="form-check-label" for="formCheckDamaged">
        Show Damaged Goods
      </label>
    </div>

    <div v-if="data.type == 'invoice'" class="form-check mb-2">
      <input
        class="form-check-input"
        v-model="data.mergeInvoiceItems"
        :true-value="1"
        :false-value="0"
        @change="updateInvoice('mergeInvoiceItems')"
        type="checkbox"
        id="formCheckMerge"
      />
      <label class="form-check-label" for="formCheckMerge">
        Merge New Invoice Lines
      </label>
    </div>
  </div>
</template>

<script>
import { CONSTANTS } from "@/constants/constants";
import BuyerInputGroup from "@/components/invoice/inputGroups/BuyerInputGroup";
import DateInput from "@/components/utils/DateInput";

export default {
  name: "InvoiceDetailsInputGroup",
  components: { DateInput, BuyerInputGroup },
  data() {
    return {
      invoiceDate: "",
      billerID: "",
    };
  },
  computed: {
    headers() {
      return CONSTANTS.INVOICE_HEADERS;
    },
    data() {
      return this.$store.getters.invoiceSummary;
    },
    billers() {
      return this.$store.getters.allBillers;
    },
  },
  methods: {
    async updateInvoice(key) {
      if (key === "date") {
        this.data[key] = this.invoiceDate;
      }
      await this.$store.dispatch("editInvoice", {
        id: this.data.id,
        [key]: this.data[key],
      });
      if (
        ![
          "showDamagedGoods",
          "showIndividualMargin",
          "showSuggestedAnalysis",
          "mergeInvoiceItems",
        ].includes(key)
      ) {
        await this.$store.dispatch("getInvoice", this.data.id);
      }
    },
    async updateBillerID(selectedBillerID) {
      console.log(selectedBillerID);
      this.data["billerID"] = selectedBillerID;
      await this.$store.dispatch("editInvoice", {
        id: this.data.id,
        billerID: this.data.billerID,
      });
    },
    priceFormat(price) {
      return `$${price
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`.replace("$-", "-$");
    },
  },
  async created() {
    this.invoiceDate = this.$store.getters.invoiceSummary.date;
    this.billerID = this.$store.getters.invoiceSummary.billerID;
  },
};
</script>

<style scoped>
select {
  webkit-appearance: auto;
  -moz-appearance: button-arrow-down;
  appearance: auto;
}
</style>
